"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var antd_1 = require("antd");
var MinScaleDenominator_1 = __importDefault(require("./MinScaleDenominator"));
var MaxScaleDenominator_1 = __importDefault(require("./MaxScaleDenominator"));
var _get = require('lodash/get');
var _cloneDeep = require('lodash/cloneDeep');
var LocaleWrapper_1 = require("../LocaleWrapper/LocaleWrapper");
var en_US_1 = __importDefault(require("../../locale/en_US"));
/**
 * Combined UI for input fields for the minimum and maximum scale of a rule.
 */
var ScaleDenominator = /** @class */ (function (_super) {
    __extends(ScaleDenominator, _super);
    function ScaleDenominator() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Reacts on changing min scale and pushes the updated scaleDenominator to the 'onChange' function
         */
        _this.onMinScaleDenomChange = function (minScaleDenominator) {
            var onChange = _this.props.onChange;
            var scaleDenominator = _cloneDeep(_this.props.scaleDenominator);
            if (!scaleDenominator) {
                scaleDenominator = {};
            }
            scaleDenominator.min = minScaleDenominator;
            if (onChange) {
                onChange(scaleDenominator);
            }
        };
        /**
         * Reacts on changing max scale and pushes the updated scaleDenominator to the 'onChange' function
         */
        _this.onMaxScaleDenomChange = function (maxScaleDenominator) {
            var onChange = _this.props.onChange;
            var scaleDenominator = _cloneDeep(_this.props.scaleDenominator);
            if (!scaleDenominator) {
                scaleDenominator = {};
            }
            scaleDenominator.max = maxScaleDenominator;
            if (onChange) {
                onChange(scaleDenominator);
            }
        };
        return _this;
    }
    ScaleDenominator.prototype.render = function () {
        var locale = this.props.locale;
        return (React.createElement("div", { className: "gs-scaledenominator" },
            React.createElement(antd_1.Row, { gutter: 16 },
                React.createElement(antd_1.Col, { span: 12, className: "gs-small-col" },
                    React.createElement(MinScaleDenominator_1.default, { value: _get(this.props, 'scaleDenominator.min'), onChange: this.onMinScaleDenomChange, label: locale.minScaleDenominatorLabelText, placeholder: locale.minScaleDenominatorPlaceholderText })),
                React.createElement(antd_1.Col, { span: 12, className: "gs-small-col" },
                    React.createElement(MaxScaleDenominator_1.default, { value: _get(this.props, 'scaleDenominator.max'), onChange: this.onMaxScaleDenomChange, label: locale.maxScaleDenominatorLabelText, placeholder: locale.maxScaleDenominatorPlaceholderText })))));
    };
    ScaleDenominator.defaultProps = {
        locale: en_US_1.default.GsScaleDenominator
    };
    ScaleDenominator.componentName = 'ScaleDenominator';
    return ScaleDenominator;
}(React.Component));
exports.ScaleDenominator = ScaleDenominator;
exports.default = LocaleWrapper_1.localize(ScaleDenominator, ScaleDenominator.componentName);
//# sourceMappingURL=ScaleDenominator.js.map